import React from 'react';

import { useDialogs } from '../../../hooks/Dialogs';
import Dialog from './Dialog';


function Dialogger() {
    const { dialogs } = useDialogs();

    return (
        <div id='stx-dialogs'>
            {
                dialogs.map(dialog => <Dialog key={dialog.id} {...dialog} />)
            }
        </div>
    );
}

export default Dialogger;
